module.exports = __webpack_public_path__ + "img/logo-steam.27acd132.svg";